import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import enLang from "./en.json";
import ruLang from "./ru.json";
import trLang from "./tr.json";

i18n
	.use(LanguageDetector) // Automatically detect language
	.use(initReactI18next) // Bind react-i18next to i18next
	.init({
		resources: {
			en: { translation: enLang },
			ru: { translation: ruLang },
			tr: { translation: trLang },
		},
		fallbackLng: ["tr", "ru", "en"], // Fallback languages in order
		lng: "tr", // Default language if no detection is made
		debug: process.env.NODE_ENV === "development", // Enable debug mode in development
		interpolation: {
			escapeValue: false, // React already escapes values
		},
		detection: {
			order: ["localStorage", "querystring", "cookie", "navigator", "htmlTag"], // Detection priority
			caches: ["localStorage", "cookie"], // Where to store detected language
		},
		react: {
			useSuspense: true, // Ensure translations are loaded before rendering
		},
	});

export default i18n;
